export default [{
  path: '/quiz-plan',
  name: 'quizPlan',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/quiz/quizPlan/index')
}]
